import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { UnitSystem, UnitSystemData } from '../utils/unitUtils';
import { UnitSystems } from '../utils/unitUtils';

const UnitSystemContext = createContext<[UnitSystemData, (param: UnitSystem) => void]>([
  UnitSystems.metric,
  () => {},
]);
const useUnitSystem = () => useContext(UnitSystemContext);

function loadUnitSystem() {
  const unitSystem = localStorage.getItem('unit_system');

  if (JSON.parse(unitSystem ?? 'null')) {
    try {
      return JSON.parse(unitSystem) as UnitSystemData;
    } catch {
      return UnitSystems.metric;
    }
  }
  return UnitSystems.metric;
}

export function UnitSystemContextProvider({ children }: Readonly<React.PropsWithChildren>) {
  const [data, setData] = useState<UnitSystemData>(loadUnitSystem());

  const setUnitSystem = useCallback((newUnitSystem: UnitSystem) => {
    const newUnitSystemData =
      newUnitSystem === 'metric' ? UnitSystems.metric : UnitSystems.imperial;
    setData(newUnitSystemData);
    localStorage.setItem('unit_system', JSON.stringify(newUnitSystemData));
  }, []);

  const value = useMemo<[UnitSystemData, (param: UnitSystem) => void]>(
    () => [data, setUnitSystem],
    [data, setUnitSystem]
  );

  return <UnitSystemContext.Provider value={value}>{children}</UnitSystemContext.Provider>;
}

export default useUnitSystem;
